<template>
  <a-form-item class="pwdInput">
    <a-input-password
      class="inputPassword"
      :placeholder="placeholder || $t('user.login.pwd.placeholder')"
      v-decorator="[
        'password',
        {
          rules: [
            {
              validator: checkFn,
            },
          ],
        },
      ]"
    >
      <icon-font slot="prefix" type="locker" />
    </a-input-password>
  </a-form-item>
</template>

<script>
/** 密码输入框 */
import IconFont from "@/components/IconFont";

export default {
  components: {
    IconFont,
  },
  props: {
    placeholder: {
      type: String,
      default: "",
    },
  },
  methods: {
    checkFn(rule, value, callback) {
      const maxLength = 16;
      const minLength = 6;
      const passwordRegex = new RegExp(/^[A-Za-z0-9(!@#%&\\$\\&\\*)]+$/, "i");

      if (!value || value.length > maxLength || value.length < minLength) {
        callback(new Error(this.$t("user.register.pwd.placeholder")));
      }
      if (!passwordRegex.test(value)) {
        callback(new Error(this.$t("user.pwd.inlegal.error")));
      }
      callback();
    },
  },
};
</script>

<style lang="less" scoped>
.inputPassword {
  & /deep/ .ant-input-suffix {
    font-size: 14px !important;
  }
}
</style>
